import { ReallyClickDirective } from './really-click.directive';

export { ReallyClickDirective };